import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Asset} from '../../../../../assets-library/services/asset-library.model';
import {AssetsService} from '../../../../../assets-library/services/assets.service';
import {FileFormatService} from '../../../../../assets-library/services/fileformat.service';
import { NgClass } from '@angular/common';
import { ReadReceiptComponent } from '../read-receipt/read-receipt.component';

interface NoPreviewImg {
    src: string,
    type: string
}

@Component({
    selector: 'app-file',
    templateUrl: './file-chat-bubble.component.html',
    styleUrls: ['./file-chat-bubble.component.scss'],
    imports: [NgClass, ReadReceiptComponent]
})
export class FileComponent implements OnInit, OnChanges {
    @Input() messageSource: Boolean;
    @Input() content: any;

    fileName: string;
    fileType: string;
    fileSize: string;

    noPreviewImg: NoPreviewImg;

    constructor(private fileFormatService: FileFormatService, private assetsService: AssetsService) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.fileName = this.getFileName();
        this.fileType = this.getFileType();
        this.fileSize = this.getFileSize();
        this.noPreviewImg = this.setNoPreviewImg();
    }

    onClickDownloadFile(): void {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', this.content['src']);
        link.setAttribute('download', `${this.content['description']}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    getFileSize(): string {
        const size: number = this.content['fileSize'];

        return Math.round(size * 0.000001) < 1
            ? `${(size * 0.001).toFixed(2)} KB`
            : `${(size * 0.000001).toFixed(2)} MB`;
    }

    setNoPreviewImg(): NoPreviewImg {
        const item = this.fileFormatService.getType(this.content['type']);
        return {
            src: item.type ? '../../../assets/svg/empty.svg' : '../../../assets/svg/invalid.svg',
            type: item.type,
        };
    }

    getFileType(): string {

        if (this.content['description'] && this.content['description'].includes(".")) {
            return this.content['description'].split('.').pop()
        }

        if(this.content['type']) {
            return this.fileFormatService.getType(this.content['type']).type;
        }

        return null
    }

    getFileName(): string {
        const fileName = this.content['description'].replace(/\.[^/.]+$/, '');
        return this.content['description'] ? fileName : null;
    }
}
